<template>
	<div id="guideTextAssembly" class="guideTextAssembly">
        <div class="guide_text"  v-loading="loading">
            <!-- <div class="return" @click="return_fn" v-if="not_login">
                <i class="iconfont" style="font-size:30px;">&#xe737;</i>
            </div> -->
            <div style="width: 100%;">
                <div class="hed">
					<p class="title">{{title}}</p>
					<p class="time">{{release_time}}</p>
				</div>	
			    <div class="guide_con">
        	        <p v-html="con"></p>
        	    </div>
            </div>
            
        </div>
        
	</div>
</template>

<script>
export default {
    props:['news_id','not_login','code'],
	name: 'guide'
	,data () {
		return {
			loading:false,
            test_tit:'详情',
			title:'',
            con:`
            `,
			hed:'',
			release_time:''
		}
	}
    
	,mounted:function(option){
		this.getlist()
	}
	,watch:{
		total(){

		}
	}
	,computed:{

	}
	,methods:{
		//列表
		getlist(){
			this.loading = true
			// console.log(this.$store.state.grade_id);
			let serverSrc=this.global.serverSrc
			,qianzui=this.global.qianzui;
			let token=this.$cookies.get("token")
			let query=this.$route.query;
			this.bijiloading = true
            let url = "/news/news_detail"
            if (this.not_login) {
                url = '/news/index_news_detail'
            }
			let data = {}
			if (this.code) {
				data.code = this.code
			}else{
				data.news_id = this.news_id
			}
			this.$ajax.get(serverSrc + qianzui + url,{params:data})
			.then(res=>{
                this.title = res.data.data.title
				this.con = res.data.data.content
				this.release_time = res.data.data.release_time
				this.loading = false
				// console.log(res);
				// console.log(res.list.data);
			})
		},
        //返回
        return_fn(){
            this.$parent.return_fn()
        }
	}
	,destroyed:function(){
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
    .guide_text{
        display: flex;
    }
    .return{
        display: inline-block;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border: 2px solid blue;
        color: blue;
        border-radius: 50%;
        transform: rotate(-90deg);
        margin-left: -24px;
        margin-right: 10px;
        cursor: pointer;
    }
    .return:hover{
        border: 2px solid #47a2f1;
        color: #47a2f1;
    }
</style>


// WEBPACK FOOTER //
// src/components/dyy_assembly/guideTextAssembly.vue